import EntityStore from 'stores/EntityStore';

import {RoutineRunAs} from './RoutineTypes';

interface RoutineExecutionIdentity {
  creatorId: string | null;
  runAs: RoutineRunAs;
}

type RoutineModificationAction = 'edit' | 'pause' | 'resume' | 'run';

export function canCurrentUserModifyRoutine(
  routine: RoutineExecutionIdentity,
  action: RoutineModificationAction
): boolean {
  if (action === 'pause' || routine.runAs !== RoutineRunAs.CREATOR) {
    return true;
  }
  return routine.creatorId != null && routine.creatorId === EntityStore.currentUser()?.id;
}
